module.exports = __webpack_public_path__ + "static/media/pg_backpack_highlight.f7db4038.svg";